import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
//import LanguageDetector from 'i18next-browser-languagedetector';
import en from './i18n/en_US.json';
import pt from './i18n/pt_PT.json';
import {APP_CONFIGS} from "./config/configs";

const lang = window && window.SEARCH_WIDGET_DATA && window.SEARCH_WIDGET_DATA.lang
    ? window.SEARCH_WIDGET_DATA.lang.slice(0, 2).toLowerCase()
    : APP_CONFIGS.APP.defaultLanguage;

i18n.languages = ['en', 'pt'];

i18n
    // detect user language
    // learn more: https://github.com/i18next/i18next-browser-languageDetector
    //.use(LanguageDetector)
    // pass the i18n instance to react-i18next.
    .use(initReactI18next)
    // init i18next
    // for all options read: https://www.i18next.com/overview/configuration-options
    .init({
        resources: {
            'en': {
                translation: en
            },
            'pt': {
                translation: pt
            }
        },
        fallbackLng: lang,
        debug: false,
        keySeparator: false, // we use content as keys
        interpolation: {
            escapeValue: false, // not needed for react!!
            formatSeparator: ','
        },
        react: {
            wait: false,
            useSuspense: false
        }

    });

export default i18n;